import { Box, FormControlLabel, Checkbox, CheckboxProps } from '@mui/material';
import React, { forwardRef } from 'react';

interface Props extends CheckboxProps {
  label?: string;
  error?: boolean;
}

function FormCheckbox(
  { label, error, ...props }: Props,
  ref: CheckboxProps['inputRef'],
) {
  return (
    <Box>
      <FormControlLabel
        sx={{ color: error ? 'error.main' : undefined }}
        control={
          <Checkbox
            inputRef={ref}
            sx={{ color: error ? 'error.main' : undefined }}
            color="success"
            {...props}
            checked={!!props.value}
          />
        }
        label={label || ''}
      />
    </Box>
  );
}

export default forwardRef(FormCheckbox);
